export default {
  SET_GET_INSTITUTIONS(state, data) {
    state.institutions = data.data.data;
  },
  SET_GET_SKILLS(state, data) {
    state.skills = data;
  },
  SET_GET_COMPANIES(state, data) {
    state.companies = data.data.data;
  },

  SET_ADD_NEW_SKILL(state, data) {
    const newSkill = {
      id: data.data[0].id,
      name: data.data[0].name,
      skill_type: data.data[0].skill_type,
    };

    state.skills.push(newSkill);
  },
  SET_GET_LANGUAGE_SKILLS(state, data) {
    state.languageSkills = data;
  },
  SET_GET_SOFT_SKILLS(state, data) {
    state.softSkills = data;
  },
  SET_GET_TECHNICAL_SKILLS(state, data) {
    state.technicalSkills = data;
  },
  SET_GET_CERTIFIED_SKILLS(state, data) {
    state.certifiedSkills = data;
  },
  SET_GET_STATS(state, data) {
    state.statistics = data.data;
  },
};
